import React, { Component } from 'react'
import backButton from '../assets/images/ic_back.png'
import { CCol, CImage, CRow } from '@coreui/react'

export default class PageHeader extends Component {
    render() {
        return (
            <>
                <CRow>
                    <CCol md="6">
                        <h5>
                            {
                                this.props.onBackPressed ?
                                    <CImage
                                        src={backButton}
                                        className="backButton"
                                        onClick={() => this.props.onBackPressed()} />
                                    : null
                            }

                            {this.props.page_name}
                        </h5>
                    </CCol>
                    <CCol md="6" className="alignRight">
                        {this.props.children ? this.props.children : null}
                    </CCol>
                </CRow>

                <hr />
            </>
        )
    }
}
